import { useEffect, useState } from 'react';
import { tierInfo } from '../data/mockData';
import { useApp } from '../context/AppContext';
import { api } from '../lib/api';

export function TiersPage() {
  const { currentUser, refreshSongs } = useApp();
  const [mode, setMode] = useState('MOCK');
  const [sub, setSub] = useState<any>(null);
  const [busy, setBusy] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);

  const currentTier = currentUser?.tier ?? 'FREE';

  const load = async () => {
    try {
      const [c, s] = await Promise.all([api.contracts(), api.mySubscription()]);
      setMode(c.mode); setSub(s.subscription);
    } catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const upgrade = async (tier: string) => {
    setBusy(tier); setMsg(null);
    try {
      const r = await api.checkout(tier);
      setMsg(`You're now on ${tier}. Payment mode: ${r.mode}. Limits apply immediately.`);
      await load(); await refreshSongs();
    } catch (e: any) { setMsg(e?.detail?.message || e?.message || 'Failed'); }
    finally { setBusy(null); }
  };
  const cancel = async () => { await api.cancelSub(); setMsg('Subscription set to cancel at period end.'); await load(); };
  const resume = async () => { await api.resumeSub(); setMsg('Subscription resumed.'); await load(); };

  return (
    <div className="grid">
      <div className="card">
        <div className="section-title" style={{ margin: 0 }}>Contracts</div>
        <div className="muted mb-16" style={{ fontSize: 13 }}>
          Every new creator begins on the Free Contract. Upgrade anytime. Payments run in <strong>{mode}</strong> mode{mode === 'MOCK' ? ' — no card charged in the preview. Add a Stripe key to go live.' : ' — live Stripe.'}
        </div>
        <div className="flex gap-8 wrap">
          <div className="chip chip-approved">Current: {currentTier.replace('_', ' ')}</div>
          {sub?.cancelAtPeriodEnd && <div className="chip chip-requested">Cancels at period end</div>}
        </div>
      </div>

      <div className="tier-grid">
        {tierInfo.map((t) => {
          const isCurrent = t.id === currentTier;
          return (
            <div key={t.id} className={`tier-card${isCurrent ? ' current' : ''}${t.id === 'TIER_4' ? ' vip' : ''}`}>
              <div className="flex-between mb-8">
                <strong style={{ fontSize: 17 }}>{t.name}</strong>
                {isCurrent && <span className="chip chip-gold">Current</span>}
              </div>
              <div className="tier-price" style={{ color: t.accent }}>{t.price}</div>
              <div className="muted" style={{ fontSize: 12.5, marginTop: 4 }}>{t.tagline}</div>
              <ul className="tier-list">{t.features.map((f) => <li key={f}>✓ {f}</li>)}</ul>
              <div className="divider" />
              <div className="muted" style={{ fontSize: 12 }}>
                <div>Uploads: {t.limits.uploads}</div>
                <div>Storage: {t.limits.storage}</div>
                <div>Battles: {t.limits.battles}</div>
                <div>Collabs: {t.limits.collabs}</div>
              </div>
              {!isCurrent && t.id !== 'FREE' && (
                <button className="btn btn-gold btn-sm btn-block mt-16" style={{ marginTop: 12 }} disabled={busy !== null}
                  onClick={() => upgrade(t.id)}>{busy === t.id ? 'Processing…' : 'Upgrade'}</button>
              )}
              {isCurrent && sub && t.id !== 'FREE' && (
                <div className="flex gap-8 mt-16" style={{ marginTop: 12 }}>
                  {sub.cancelAtPeriodEnd
                    ? <button className="btn btn-outline btn-sm" onClick={resume}>Resume</button>
                    : <button className="btn btn-outline btn-sm" onClick={cancel}>Cancel</button>}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="card" style={{ borderColor: 'rgba(201,162,39,0.4)' }}>
        <div className="section-title gold">Prize Memberships</div>
        <p className="muted" style={{ fontSize: 14 }}>
          Battle winners earn free Contract 4 time: 1st = 12 months, 2nd = 6 months, 3rd = 3 months. A prize begins when IAMMUZIK finalizes the battle and ends automatically — it does not convert to paid billing unless the winner actively subscribes.
        </p>
        {msg && <div className="chip chip-approved mt-16" style={{ marginTop: 12 }}>{msg}</div>}
      </div>
    </div>
  );
}
